import { render, staticRenderFns } from "./CraftingItem.vue?vue&type=template&id=678e055a&scoped=true"
import script from "./CraftingItem.vue?vue&type=script&lang=js"
export * from "./CraftingItem.vue?vue&type=script&lang=js"
import style0 from "./CraftingItem.vue?vue&type=style&index=0&id=678e055a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e055a",
  null
  
)

export default component.exports